import { separate } from "./separate";

export const sumPrice = (count, price) => {
  const result = separate(count * price);
  return result;
};
